import { render } from "./FathersTable.vue?vue&type=template&id=11da0c5d"
import script from "./FathersTable.vue?vue&type=script&lang=js"
export * from "./FathersTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__